export default __webpack_public_path__ + "static/media/alerttriangle.9efecbdb.png";